const ChatBubbleIcon = () => (
  <svg
    width='66'
    height='66'
    viewBox='0 0 66 66'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {' '}
    <path
      d='M65 32.7451C65 50.4091 50.664 64.7451 33 64.7451C15.336 64.7451 1 50.4091 1 32.7451C1 15.0811 15.336 0.745117 33 0.745117C50.664 0.745117 65 15.0171 65 32.7451Z'
      stroke='#1C3A13'
    />{' '}
    <mask
      id='mask0_2113_1213'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='1'
      y='0'
      width='64'
      height='65'
    >
      {' '}
      <path
        d='M65 32.7451C65 50.4091 50.664 64.7451 33 64.7451C15.336 64.7451 1 50.4091 1 32.7451C1 15.0811 15.336 0.745117 33 0.745117C50.664 0.745117 65 15.0171 65 32.7451Z'
        fill='#D9D9D9'
      />{' '}
    </mask>{' '}
    <g mask='url(#mask0_2113_1213)'>
      {' '}
      <path
        d='M39.5781 49.8118L40.0111 49.5618L39.8668 49.3118H39.5781V49.8118ZM42.8978 55.5618L42.4648 55.8118L42.4648 55.8118L42.8978 55.5618ZM45.4959 55.5618L45.9289 55.8118L45.9289 55.8118L45.4959 55.5618ZM48.8709 49.7161L48.8059 49.2203L48.5613 49.2524L48.4379 49.4661L48.8709 49.7161ZM17.5 38.6118C17.5 32.7024 22.2906 27.9118 28.2 27.9118V26.9118C21.7383 26.9118 16.5 32.1501 16.5 38.6118H17.5ZM28.2 49.3118C22.2906 49.3118 17.5 44.5213 17.5 38.6118H16.5C16.5 45.0735 21.7383 50.3118 28.2 50.3118V49.3118ZM39.5781 49.3118H28.2V50.3118H39.5781V49.3118ZM43.3309 55.3118L40.0111 49.5618L39.1451 50.0618L42.4648 55.8118L43.3309 55.3118ZM45.0629 55.3118C44.678 55.9785 43.7158 55.9785 43.3309 55.3118L42.4648 55.8118C43.2346 57.1451 45.1591 57.1451 45.9289 55.8118L45.0629 55.3118ZM48.4379 49.4661L45.0629 55.3118L45.9289 55.8118L49.304 49.9661L48.4379 49.4661ZM58.1 38.6118C58.1 44.0445 54.0507 48.5323 48.8059 49.2203L48.936 50.2118C54.672 49.4593 59.1 44.5531 59.1 38.6118H58.1ZM47.4 27.9118C53.3094 27.9118 58.1 32.7024 58.1 38.6118H59.1C59.1 32.1501 53.8617 26.9118 47.4 26.9118V27.9118ZM28.2 27.9118H47.4V26.9118H28.2V27.9118Z'
        fill='#1C3A13'
      />{' '}
      <circle cx='31.3998' cy='38.6118' r='1.6' fill='#1C3A13' />{' '}
      <circle cx='37.7997' cy='38.6118' r='1.6' fill='#1C3A13' />{' '}
      <circle cx='44.1996' cy='38.6118' r='1.6' fill='#1C3A13' />{' '}
      <g filter='url(#filter0_d_2113_1213)'>
        {' '}
        <path
          d='M13.0853 25.2785V24.7785H12.7966L12.6523 25.0285L13.0853 25.2785ZM9.76554 31.0285L10.1986 31.2785L10.1986 31.2785L9.76554 31.0285ZM7.16747 31.0285L7.60048 30.7785L7.60048 30.7785L7.16747 31.0285ZM3.78182 25.1643L4.21483 24.9143L4.09512 24.707L3.85853 24.6703L3.78182 25.1643ZM28.1665 15.6785C28.1665 10.1004 23.6446 5.57846 18.0665 5.57846V6.57846C23.0923 6.57846 27.1665 10.6527 27.1665 15.6785H28.1665ZM18.0665 25.7785C23.6446 25.7785 28.1665 21.2565 28.1665 15.6785H27.1665C27.1665 20.7043 23.0923 24.7785 18.0665 24.7785V25.7785ZM13.0853 25.7785H18.0665V24.7785H13.0853V25.7785ZM10.1986 31.2785L13.5183 25.5285L12.6523 25.0285L9.33253 30.7785L10.1986 31.2785ZM6.73445 31.2785C7.50425 32.6118 9.42875 32.6118 10.1986 31.2785L9.33253 30.7785C8.94763 31.4451 7.98538 31.4451 7.60048 30.7785L6.73445 31.2785ZM3.34881 25.4143L6.73445 31.2785L7.60048 30.7785L4.21483 24.9143L3.34881 25.4143ZM-4.8335 15.6785C-4.8335 20.7258 -1.13168 24.9075 3.70511 25.6584L3.85853 24.6703C-0.498568 23.9938 -3.8335 20.2251 -3.8335 15.6785H-4.8335ZM5.26651 5.57846C-0.311569 5.57846 -4.8335 10.1004 -4.8335 15.6785H-3.8335C-3.8335 10.6527 0.240715 6.57846 5.26651 6.57846V5.57846ZM18.0665 5.57846H5.26651V6.57846H18.0665V5.57846Z'
          fill='#1C3A13'
        />{' '}
      </g>{' '}
    </g>{' '}
    <defs>
      {' '}
      <filter
        id='filter0_d_2113_1213'
        x='-32.9585'
        y='-18.0465'
        width='89.25'
        height='82.95'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        {' '}
        <feFlood flood-opacity='0' result='BackgroundImageFix' />{' '}
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />{' '}
        <feOffset dy='4.5' /> <feGaussianBlur stdDeviation='14.0625' />{' '}
        <feComposite in2='hardAlpha' operator='out' />{' '}
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />{' '}
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_2113_1213'
        />{' '}
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_2113_1213'
          result='shape'
        />{' '}
      </filter>{' '}
    </defs>{' '}
  </svg>
);

export default ChatBubbleIcon;
